import { TFunction } from 'i18next';

enum DeviceStateEnum {
	Available = 'available',
	None = 'none',
	Unknown = 'unknown',
}

export function getDeviceStateLabel(deviceState: DeviceStateEnum, t: TFunction): string {
	switch (deviceState) {
		case DeviceStateEnum.Available:
			return t('deviceState.labels.available', { ns: 'entities' });
		case DeviceStateEnum.None:
			return t('deviceState.labels.none', { ns: 'entities' });
		case DeviceStateEnum.Unknown:
			return t('general.unknown', { ns: 'entities' });
		default:
			return t('general.unknown', { ns: 'entities' });
	}
}

export default DeviceStateEnum;
